exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".black{color:#000}.bg-black{background-color:#000}.white{color:#fff}.bg-white{background-color:#fff}.red{color:red}.valencia{color:#d94a38}.avocado{color:#848c58}.bg-avocado{background-color:#848c58}.verdigris{color:#4d5234}.bg-verdigris{background-color:#4d5234}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./game-ui/css/20-boje.css
// module id = 25
// module chunks = 0